import React from 'react';
import styled from '@emotion/styled';
import { Config, StyleLibrary } from '@vm/omega-shared-component-webapp';
import { parseHtml } from '../helpers';

const { ComponentStyles, pxToRem } = StyleLibrary;

type AccordionDetailsContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  expanded: boolean;
};

const AccordionDetailsContainer = styled.div<AccordionDetailsContainerProps>(props => ({
  ...ComponentStyles.renderedHtmlStyle,
  maxHeight: props.expanded ? '1000px' : 0,
  overflow: props.expanded ? 'visible' : 'hidden',
  paddingBottom: props.expanded ? pxToRem(48) : 0,
  paddingRight: props.expanded ? pxToRem(48) : 0,
  transition: 'max-height 300ms ease',
}));

type Props = {
  description: string;
  expanded?: boolean;
  id: string;
  index: number;
};

export const AccordionDetails: React.FC<Props> = ({ expanded, description, id, index }) => {
  return (
    <AccordionDetailsContainer hidden={!expanded} id={id} expanded={expanded} role='region' aria-labelledby={`accordion${index}`} data-testid='mp-accordion-details'>
      {parseHtml(description)}
    </AccordionDetailsContainer>
  );
};
